import { Injectable } from '@angular/core';
import { AdminOrderListVM, OrderStatusVM, ProductWarrantyItem, UpdateDeliveryPriceVM } from '../models/customer/customer.model';
import { ApiService } from './Common/api.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class AdminOrderListService {

  constructor(private _api: ApiService) { }

  showAdminAllOrderlisting(adminOrderList: AdminOrderListVM) {
    return this._api.post(UrlHelperService.getAdminOrederListing, adminOrderList)
  }

  getAdminOrderDetail(productId) {
    return this._api.post(UrlHelperService.adminOrderDetail + productId)
  }

  adminUpdateStatus(orderStatus: OrderStatusVM){
    return this._api.post(UrlHelperService.adminOrderStatusChange, orderStatus)
  }

  getAdminInvoiceOrderDetail(id) {
    return this._api.post(UrlHelperService.adminInvoiceOrderDetail + id)
  }

  adminDeliveryPriceUpdate(updateDeliveryPrice: UpdateDeliveryPriceVM){
    return this._api.post(UrlHelperService.adminDeliveryPriceUpdated, updateDeliveryPrice)
  }
}
